import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export function setupAuthListener() {
  const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
    if (event === 'SIGNED_OUT') {
      toast.info("Session ended", {
        description: "Please sign in again to continue"
      });
      
      // Store current path for redirect after login
      const currentPath = window.location.pathname;
      if (currentPath !== '/auth' && currentPath !== '/') {
        sessionStorage.setItem('redirectAfterLogin', currentPath);
      }
    }
    
    if (event === 'TOKEN_REFRESHED') {
      console.log('Auth token refreshed');
    }
    
    if (event === 'SIGNED_IN' && session) {
      // Check for stored redirect path
      const redirectPath = sessionStorage.getItem('redirectAfterLogin');
      if (redirectPath) {
        sessionStorage.removeItem('redirectAfterLogin');
        window.location.href = redirectPath;
      }
    }
  });

  return authListener;
}

export function storeIntendedDestination(path: string) {
  sessionStorage.setItem('redirectAfterLogin', path);
}

export function getIntendedDestination(): string | null {
  return sessionStorage.getItem('redirectAfterLogin');
}

export function clearIntendedDestination() {
  sessionStorage.removeItem('redirectAfterLogin');
}
